export default "__VITE_ASSET__D0Rrc9ue__"